import AdvancedPotionMakingV2PrototypeFull from "./advanced-potion-making-v2-prototype-full";
import AdvancedPotionMakingV2PrototypeTextBlock from "./advanced-potion-making-v2-prototype-text-block";
import AdvancedPotionMakingV3DiyCover from "./advanced-potion-making-v3-diy-cover";
import MaraudersMapV7PrisonerOfAzkabanPrototype from "./marauders-map-v7-prisoner-of-azkaban-prototype";
import { ReplicaItemType } from "types";
import TalesOfBeedleTheBardV1DiyCover from "./the-tales-of-beedle-the-bard-v1-diy-cover";
import TalesOfBeedleTheBardV1GradeB from "./the-tales-of-beedle-the-bard-v1-grade-b";
import TheDailyProphetV2DarkMarkSparksPanicGradeB from "./the-daily-prophet-v2-dark-mark-sparks-panic";
import TheQuibblerV1HarryInHidingGradeB from "./the-quibbler-v1-harry-in-hiding";
import TheQuibblerV1HowFarWillFudgeGoGradeB from "./the-quibbler-v1-how-far-will-fudge-go";
import TheQuibblerV1IssueNo1GradeB from "./the-quibbler-v1-issue-no-1";
import TheQuibblerV1MuggleMurdersRiseGradeB from "./the-quibbler-v1-muggle-murders-rise";
import TheQuibblerV1SpectrespecsGradeB from "./the-quibbler-v1-spectrespecs-grade-b";
import TheQuibblerV1UndesirableNo1GradeB from "./the-quibbler-v1-undesirable-no-1";
import TheQuibblerV1YouKnowWhoGradeB from "./the-quibbler-v1-you-know-who-grade-b";

const replicaItems: ReplicaItemType[] = [
  TalesOfBeedleTheBardV1GradeB,
  TalesOfBeedleTheBardV1DiyCover,
  AdvancedPotionMakingV3DiyCover,
  AdvancedPotionMakingV2PrototypeFull,
  AdvancedPotionMakingV2PrototypeTextBlock,
  TheDailyProphetV2DarkMarkSparksPanicGradeB,
  MaraudersMapV7PrisonerOfAzkabanPrototype,
  TheQuibblerV1SpectrespecsGradeB,
  TheQuibblerV1YouKnowWhoGradeB,
  TheQuibblerV1UndesirableNo1GradeB,
  TheQuibblerV1MuggleMurdersRiseGradeB,
  TheQuibblerV1IssueNo1GradeB,
  TheQuibblerV1HowFarWillFudgeGoGradeB,
  TheQuibblerV1HarryInHidingGradeB,
];

export default replicaItems;
